// eslint-disable-next-line import/prefer-default-export
export const ScheduleEventServiceItemIconStatusConstants = {
  active: {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Upcoming service',
      appendOnMultiDate: ' between',
      startDatePath: 'next_starts_at',
      endDatePath: 'next_ends_at',
    },
  },

  overdue: {
    icon: {
      type: 'calendar',
      color: 'danger',
    },
    status: {
      text: 'Upcoming service',
      appendOnMultiDate: ' between',
      startDatePath: 'next_starts_at',
      endDatePath: 'next_ends_at',
    },
  },

  cancelled: {
    icon: {
      type: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'Cancelled on',
      endDatePath: 'status_set_at',
    },
  },

  completed: {
    icon: {
      type: 'checkmark',
      color: 'primary',
    },
    status: {
      text: 'Completed on',
      endDatePath: 'status_set_at',
    },
  },

  ended: {
    icon: {
      type: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'Ended on',
      endDatePath: 'status_set_at',
    },
  },

  pending: {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Upcoming service',
      appendOnMultiDate: ' between',
      startDatePath: 'schedule.next_starts_at',
      endDatePath: 'schedule.next_ends_at',
    },
  },

  scheduled: {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Upcoming service',
      appendOnMultiDate: ' between',
      startDatePath: 'starts_at',
      endDatePath: 'ends_at',
    },
  },

  skipped: {
    icon: {
      type: 'calendar',
      color: 'tertiary',
    },
    status: {
      text: 'Skipped on',
      endDatePath: 'status_set_at',
    },
  },

  rescheduled: {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Rescheduled',
      startDatePath: 'status_set_at',
    },
  },

  // Quote Specific
  'manualquote.authorized': {
    icon: {
      type: 'checkmark',
      color: 'primary',
    },
    status: {
      text: 'You approved the quote on',
      endDatePath: 'schedule.manualquote.status_set_at',
    },
  },

  'manualquote.cancelled': {
    icon: {
      type: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'Cancelled on',
      endDatePath: 'schedule.manualquote.status_set_at',
    },
  },

  'manualquote.expired': {
    icon: {
      type: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'Your quote expired on',
      endDatePath: 'schedule.manualquote.status_set_at',
    },
  },

  'manualquote.new': {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: "We'll get you a quote by",
      endDatePath: 'ends_at',
    },
  },

  'manualquote.pending': {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: "We'll get you a quote by",
      endDatePath: 'ends_at',
    },
  },

  'manualquote.ready': {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: "We'll get you a quote by",
      endDatePath: 'ends_at',
    },
  },

  'manualquote.scheduled': {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: "We'll get you a quote by",
      endDatePath: 'ends_at',
    },
  },

  'manualquote.overdue': {
    icon: {
      type: 'calendar',
      color: 'danger',
    },
    status: {
      text: "We'll get you a quote by",
      endDatePath: 'ends_at',
    },
  },

  'manualquote.rescheduled': {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Rescheduled',
      startDatePath: 'status_set_at',
    },
  },

  'manualquote.priced': {
    icon: {
      type: 'calendar',
      color: 'tertiary',
    },
    status: {
      text: 'Review and approve your quote by',
      endDatePath: 'schedule.manualquote.expires_at',
    },
  },

  'manualquote.rejected': {
    icon: {
      type: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'You rejected the quote on',
      endDatePath: 'schedule.manualquote.status_set_at',
    },
  },

  fallback: {
    icon: {
      type: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'n/a',
    },
  },
};
